export default "__VITE_ASSET__BlmnjYop__"